module.exports = __webpack_public_path__ + "static/media/Item 14.f485b0cd.jpg";